import React, { useMemo } from 'react';
import { ChakraAutocompleteField, ChakraFormSwitch } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { getOptions } from 'app/components/Song/Details/SongDetailsForm/utils';
import { Box, Grid, GridItem } from '@chakra-ui/react';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { ddlToOptions } from 'app/utils/utils';
import { TuneCoreVersionDetailsFormComponentProps } from './types';
import { useTCVersionForm } from './hooks';
import { ReleaseActions } from '../ReleaseActions';

export const TuneCoreVersionDetailsFormComponent: React.FC<TuneCoreVersionDetailsFormComponentProps> = ({
  releaseVersion,
  versionSongValidations,
  versionValidations,
  genresDDL,
  updateVersion,
  languageCodes,
  isSyncing,
}) => {
  const languages = getOptions(versionSongValidations.language, languageCodes);
  const genres = useMemo(() => ddlToOptions(genresDDL, true), [genresDDL]);

  const { control } = useTCVersionForm({
    versionValidations,
    releaseVersion,
    updateVersion,
    genresDDL,
    languageCodes,
  });

  return (
    <ContentContainer type={ContentContainerType.LIST} pb={24}>
      <ReleaseActions tab="details" syncState={isSyncing} />
      <Box>
        <Grid
          templateColumns="repeat(4, 1fr)"
          columnGap={4}
          maxW="640"
          m="auto"
        >
          <GridItem colSpan={{ base: 4, md: 2 }}>
            <ChakraAutocompleteField
              control={control}
              name="genre"
              label="Genre"
              options={genres}
              isDisabled
            />
          </GridItem>
          <GridItem colSpan={{ base: 4, md: 2 }}>
            <ChakraAutocompleteField
              control={control}
              name="language"
              label="Language"
              options={languages}
              isClearable
              isDisabled
            />
          </GridItem>
          <GridItem colSpan={{ base: 4, md: 2 }}>
            <ChakraFormSwitch
              control={control}
              label="Explicit Lyrics"
              name="explicit"
              isDisabled
            />
          </GridItem>
        </Grid>
      </Box>
    </ContentContainer>
  );
};
